/**
 * LOG DESCONHECIDO NÃO É "NENHUM ENVIO" (10/10/2026).
 *
 * A tela de Faturas decidia "e-mail aguardando envio" pela AUSÊNCIA de log no mapa. Mas o mapa só tem log de quem foi
 * carregado com sucesso: com a API dos logs fora (o `.catch(() => {})` engolia), e mesmo com ela no ar para as faturas
 * fora da lista filtrada (os logs eram buscados só para as visíveis), toda fatura aberta virava "aguardando envio". O
 * cartão "Precisa de você" contava todas, o envio em lote perdia o aviso de "JÁ receberam, serão REENVIADAS", e o
 * próprio modal mandava usar essa entrada para "enviar só a quem nunca recebeu": e-mail repetido para o cliente.
 *
 * Agora a pergunta tem três respostas, e "não sei" é uma delas.
 */
/**
 * O servidor recusa mais de 200 ids por consulta de log (email-log.controller: "Maximum 200 entityIds allowed", 400).
 * A tela mandava todos os visíveis de uma vez: com "Todos os meses" eram mais de mil, o 400 caía no catch mudo e toda
 * aberta virava "aguardando envio". Visto na prévia local de 10/10/2026.
 */
export const LIMITE_DE_IDS_POR_CONSULTA = 200;

export function emBlocos<T>(xs: T[], tamanho = LIMITE_DE_IDS_POR_CONSULTA): T[][] {
  const out: T[][] = [];
  for (let i = 0; i < xs.length; i += tamanho) out.push(xs.slice(i, i + tamanho));
  return out;
}

export type SituacaoDoEnvio = 'fora' | 'aguardando' | 'enviado' | 'desconhecido';

/** O cliente recebe a fatura por e-mail? (tipo de entrega diferente de "nenhum" e algum e-mail financeiro). */
export function clienteRecebePorEmail(client: any): boolean {
  if (!client) return false;
  if ((client.emailDeliveryType || 'nf_fatura_boleto') === 'nenhum') return false;
  const financeiros = (client.emails || []).filter((e: any) => e.type === 'Financeiro').map((e: any) => e.email).filter(Boolean);
  return financeiros.length > 0 || !!client.emailFinancial;
}

/**
 * - `fora`: a regra não se aplica (não está Aberta, ou o cliente não recebe por e-mail);
 * - `desconhecido`: o log desta fatura não foi carregado com sucesso, então NÃO se sabe se já foi enviado;
 * - `enviado` / `aguardando`: o log foi lido e tem (ou não tem) envio.
 */
export function situacaoDoEnvio(inv: any, client: any, logs: any[] | undefined, logConhecido: boolean): SituacaoDoEnvio {
  if (inv?.status !== 'Aberta') return 'fora';
  if (!clienteRecebePorEmail(client)) return 'fora';
  if (!logConhecido) return 'desconhecido';
  return logs && logs.length > 0 ? 'enviado' : 'aguardando';
}
